import DependencyInjector from "./DependencyInjector";

/**
 *  Select2 Init (jQuery)
 *  params: - component (to load select2 module)
 *          - otherOptions
 *
 */
export const Select2Init = (otherOptions = {}) => {
  new DependencyInjector().loadSelect2AndExecute(
    () => {
      function formatOption(option) {
        // no icon
        if ($(option.element).data("icon") === undefined) {
          return $(`<span ${$(option.element).hasClass("unavailable") ? 'class="unavailable"' : ""}>
              ${option.text}
            </span>`);
        }
        return $(`<span ${$(option.element).hasClass("unavailable") ? 'class="unavailable"' : ""}>
            ${option.text}
            <i class="${$(option.element).data("icon")} --m"></i>
          </span>`);
      }

      function formatSelection(option) {
        // no icon
        if ($(option.element).data("message")) {
          return $(`<span>
              ${$(option.element).data("message")}
              ${option.text}
              <i class="icon-chevron-down --m"></i>
            </span>`);
        }

        return $(`<span>
            ${option.text}
            <i class="icon-chevron-down --m"></i>
          </span>`);
      }

      let options = {
        templateResult: formatOption,
        templateSelection: formatSelection,
      };

      // get custom options
      const $select = $("select.custom-select__select");
      const placeholder = $select.attr("data-placeholder");

      options = {
        ...options,
        ...otherOptions,
        ...(placeholder ? { placeholder: placeholder } : {}),
      };

      // init
      $select.select2(options);

      // events
      $select.on("select2:select", (elm) => {
        // elm.target = real select, contains array with options
        try {
          if ($(elm.target).length > 0) {
            // get select2
            const select2 = $(elm.target).parent().find(".select2-container .selection");
            // get select2 container
            const selectContainer = $(select2).find(".select2-selection.select2-selection--single");
            const placeholder = selectContainer.find(".select2-selection__placeholder");
            if (placeholder.length === 0) {
              // apply style class
              $(selectContainer).addClass("selected");
            }
          }
        } catch (e) {
          console.warn('"select active" style application failed!', e);
        }
      });

      // "on load" (no load event found..)
      $select.each((index, sel) => {
        // if a value is selected, trigger the change to update style
        $(sel)
          .children("option")
          .each((index, option) => {
            if (option.selected && !option.disabled) {
              $(sel).trigger("select2:select");
            }
          });
      });
    },
    (error) => {
      console.error("failed to load select2", error.stack);
    },
  );
};
